import { Request } from '../../../httpClient/serverApi/requests/Request';
import { GrantLicenseModes } from './SyncActiveDirectoryGroupRequest';

export interface ICreateGroupParams {
  name: string;
  grantLicenseMode?: GrantLicenseModes;
  siteRole?: string;
}

export interface ICreateGroupResult {
}

export class CreateGroupRequest extends Request<ICreateGroupParams, ICreateGroupResult> {
  constructor(params: ICreateGroupParams) {
    super('createGroup', params);
  }
}
